export default {
  props: ["signedInUser", "data"],

  methods: {
    handleClick,
  },
};

function handleClick(data, isContainer) {
  let url = "";

  if (isContainer) {
    url = `/${this.$utils.urlSafeString(data.name)}/${data.id}/products`;
  } else if (data.parentName) {
    url = `/${this.$utils.urlSafeString(data.parentName)}/${this.$utils.urlSafeString(data.name)}/${data.id}/products`;
  } else {
    url = `/edits/${this.$utils.urlSafeString(data.name)}/${data.id}/products`;
  }

  this.$emit("close-dropdown");
  this.$router.push({ path: url }, () => this.$eventBus.$emit("init-search"));
}
